<template>
  <div class="ele-body">
    <el-card shadow="never">
      <h3 style="margin-top:0;">数据清理</h3>
      <el-form :model="form" label-width="100px" style="max-width:640px;">
        <el-form-item label="清理范围">
          <el-select v-model="form.table" placeholder="请选择" class="ele-block">
            <el-option v-for="item in scopeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker v-model="form.time" type="datetimerange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;" />
        </el-form-item>
        <el-form-item>
          <el-button type="danger" :loading="loading" @click="submit"
            v-if="permission.includes('sys:shuju:edit')">执行清理</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { loadDictOptions } from '@/utils/dict';

export default {
  name: 'ConfigShuju',
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return { form: { table: 1, time: [] }, loading: false, scopeOptions: [] };
  },
  mounted() {
    loadDictOptions('clean_data_scope', { numberValue: true })
      .then((list) => { this.scopeOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  methods: {
    submit() {
      if (!this.form.table) { this.$message.warning('请选择'); return; }
      if (!this.form.time || this.form.time.length !== 2) { this.$message.warning('请选择'); return; }
      this.$confirm('确认按所选条件清理数据？此操作不可恢复', '警告', { type: 'warning' })
        .then(() => {
          this.loading = true;
          return this.$http.post('/configweb/deleteshuju', this.form);
        })
        .then((res) => {
          if (!res) return;
          if (res.data.code === 0) this.$message.success(res.data.msg || '清理成功');
          else this.$message.error(res.data.msg || '清理失败');
        })
        .catch(() => {})
        .finally(() => { this.loading = false; });
    }
  }
};
</script>
